/* TODG size core: shared by the size finder band (collection pages) and the inline size finder (product pages).
   One place for the rules: which row decides, the nearest-midpoint rule for overlapping ranges, limit rows, the product's between-sizes rule. */
(function () {
  if (window.TODGSize) return;
  function measureOf(label) {
    var l = String(label || '').toLowerCase();
    // Row labels may be translated (fi, sv); match by meaning, not by the English text.
    if (/underbust|rinnanalus|underbyst/.test(l)) return null;
    // Garment rows measured at rest (men's protocol) are shown in the table but never decide a size.
    if (/(relaxed|levossa|i vila)/.test(l)) return null;
    if (/^(thigh|reisi|lår|lahkeensuu|leg opening|benöppning)/.test(l)) return 'thigh';
    if (/^(hips|lantio|höft)/.test(l)) return 'hips';
    if (/^(waist|low waist|belt line|vyötärö|matala vyötärö|vyölinja|midja|låg midja|bältlinje|linning)/.test(l)) return 'waist';
    // Bust (tops: measured 2.5 cm below the armpit) and chest (Stealth shirt: full chest) are different measurements.
    if (/^(bust|byst)/.test(l) || (/^rinnan/.test(l) && /(2[.,]5|kainalo)/.test(l))) return 'bust';
    if (/^(chest|bröst|rinnan)/.test(l)) return 'chest';
    return null;
  }
  function rowFor(t, label) {
    if (t.rows[label]) return t.rows[label];
    var k = measureOf(label);
    if (!k) return null;
    for (var key in t.rows) { if (measureOf(key) === k) return t.rows[key]; }
    return null;
  }
  function parse(rows) {
    var lines = (rows || '').split(/\n/).filter(Boolean);
    if (!lines.length) return null;
    var sizes = lines[0].split(';').slice(1), out = {};
    lines.slice(1).forEach(function (ln) {
      var c = ln.split(';'), label = c[0];
      out[label] = c.slice(1).map(function (v) {
        var m = String(v).replace(',', '.').match(/([\d.]+)\s*[–-]\s*([\d.]+)/);
        if (m) return { min: +m[1], max: +m[2] };
        var n = parseFloat(String(v).replace(',', '.'));
        return isNaN(n) ? null : { max: n };
      });
    });
    return { sizes: sizes, rows: out };
  }
  // Measurements typed in inches while the unit is cm (e.g. waist 28, hips 38) would read as "not made in your size".
  // No adult waist is under 45 cm or hips under 65 cm, so such numbers are treated as inches.
  function looksLikeInches(m) {
    if (!m || m.unit === 'in') return false;
    var ks = ['waist', 'hips', 'chest', 'bust', 'thigh'], any = false;
    for (var i = 0; i < ks.length; i++) { var v = m[ks[i]]; if (typeof v === 'number' && v > 0) { any = true; if (v >= 66) return false; } }
    return any && ((m.waist > 0 && m.waist < 45) || (m.hips > 0 && m.hips < 65) || (m.chest > 0 && m.chest < 60) || (m.bust > 0 && m.bust < 60));
  }
  function pick(p, m) {
    if (looksLikeInches(m)) { var mm = { unit: 'in' }; for (var q in m) { if (typeof m[q] === 'number') mm[q] = m[q] * 2.54; } m = mm; }
    var t = parse(p.rows), r = p.rule;
    if (!t || !r || !r.decides) return null;
    var label = null;
    for (var i = 0; i < r.decides.length; i++) { var k = measureOf(r.decides[i]); if (k && m[k]) { label = r.decides[i]; break; } }
    if (!label) return null;
    var x = m[measureOf(label)], row = rowFor(t, label), hit = [];
    if (!row) return null;
    if (row.every(function (cell) { return !cell || cell.min == null; })) {
      // Single values (e.g. waistband stretched): the smallest size that reaches the measurement.
      // rule.margin: the measurement must stay this many cm under the garment value, so the band is not worn at its limit.
      var mg = +(r.margin || 0);
      for (var s = 0; s < row.length; s++) { if (row[s] && row[s].max - mg >= x) { hit = [s]; break; } }
    } else
    row.forEach(function (c, i) { if (c && c.min != null && x >= c.min && x <= c.max) hit.push(i); });
    if (hit.length > 1) {
      // Overlapping ranges: the size whose range midpoint is nearest the measurement; a tie keeps both for the product's own rule.
      var best = Infinity, near = [];
      hit.forEach(function (i) { var d = Math.abs(x - (row[i].min + row[i].max) / 2); if (d < best - 0.25) { best = d; near = [i]; } else if (Math.abs(d - best) <= 0.25) { near.push(i); } });
      hit = near.slice(0, 2);
    }
    if (!hit.length) {
      for (var j = 0; j < row.length - 1; j++) { if (row[j] && row[j + 1] && x > row[j].max && x < row[j + 1].min) { hit = [j, j + 1]; break; } }
    }
    if (!hit.length) return { none: true };
    (r.limit || []).forEach(function (lb) {
      var k = measureOf(lb), lim = rowFor(t, lb);
      if (!k || !m[k] || !lim) return;
      hit = hit.map(function (i) { while (i < lim.length && lim[i] && lim[i].max < m[k]) i++; return i; });
    });
    hit = hit.filter(function (i, n, a) { return i < t.sizes.length && a.indexOf(i) === n; });
    if (!hit.length) return { none: true };
    if (hit.length > 2) return null;
    if (hit.length === 2 && r.between === 'larger') hit = [hit[1]];
    if (hit.length === 2 && r.between === 'smaller') hit = [hit[0]];
    return { sizes: hit.map(function (i) { return t.sizes[i]; }) };
  }
  window.TODGSize = { measureOf: measureOf, parse: parse, pick: pick, rowFor: rowFor, looksLikeInches: looksLikeInches };
})();
